import { Typography, Avatar, Popover } from '@mui/material'
import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { clearUser } from '../../../redux/slice/user'
import { TextContainer, TypographyPopover } from './mainLayout.style'
import { useSmartCurrentUpdate } from '../../../api/current'
import http from '../../../api/http'
import { UserContainer, Main, ToolsContainer } from './HeaderRight.style'

export function timeAgo(_date: any) {
  if (!_date) {
    return '--'
  }
  // eslint-disable-next-line eqeqeq
  let date = new Date(_date == +_date ? +_date : _date)

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear().toString().substr(-2);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day} ${month} ${year}, ${hours}:${minutes}`;
}

const HeaderRight = (props: any) => {
  const userState = useAppSelector((state) => state.user);
  const userInfo = userState?.user;

  const [isPopoverOpen, setIsPopoverOpen] = useState<any>(false)

  const navigate = useNavigate()

  const dispatch = useAppDispatch()

  const smartUpdate = useSmartCurrentUpdate()

  const { currentItem } = useAppSelector((state) => state)



  const handleChangePopoverStatus = (e: any) => {
    setIsPopoverOpen(!isPopoverOpen)
  }



  const handleLogout = async () => {
    try {
      await http.post('/api/admins/auth/logout', {});
    } finally {
      localStorage.removeItem('accessToken');
      sessionStorage.removeItem('accessToken');
      dispatch(clearUser());
      navigate('/login');
    }
  }

  let popoverEl = useRef(null);
  const id = isPopoverOpen ? 'simple-popover' : undefined


  let isEditor = (global as any)?.isEditor;

  return (
    <Main data-white>
      {currentItem.isEditPage ? (
        <ToolsContainer data-animch data-last-edit data-ellipse>
          {currentItem.isEdited && (
            <button
              disabled={!isEditor}
              className={'btn'}
              onClick={async () => {
                let { type, data } = currentItem
                await smartUpdate(data, type, navigate)
              }}
            >
              Publish
            </button>
          )}
          {!currentItem.isEdited && (
            <p data-last-edit-time data-ellipse >Last edit: {timeAgo(currentItem?.data?.updatedAt)}</p>
          )}
        </ToolsContainer>
      ) : (
        <div></div>
      )}

      {userInfo && (
        <UserContainer onClick={handleChangePopoverStatus} style={{ paddingLeft: '30px' }}>
          <TextContainer data-animch={10} data-username>
            <div>
              <Typography>{userInfo?.name}</Typography>
            </div>
            <Typography variant={'body2'} data-email>
              {userInfo?.email}
            </Typography>
          </TextContainer>
          <div style={{ cursor: 'pointer' }} data-animch={10} ref={popoverEl} >
            <Avatar src={userInfo?.picture || ''} alt='profileLogo' />
          </div>
          <Popover
            id={id}
            open={isPopoverOpen}
            anchorEl={popoverEl.current}
            onClose={handleChangePopoverStatus}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}

          >
            <TypographyPopover onClick={() => {
              navigate('/config')
            }} sx={{ py: 2, px: 5 }} data-fade >
              Config
            </TypographyPopover>
            <TypographyPopover onClick={() => {
              navigate('/generator')
            }} sx={{ py: 2, px: 5 }} data-fade >
              Generator
            </TypographyPopover>
            <TypographyPopover onClick={() => {
              navigate('/dictionary')
            }} sx={{ py: 2, px: 5 }} data-fade >
              Biomarkers cache
            </TypographyPopover>
            <TypographyPopover onClick={() => {
              navigate('/definitions')
            }} sx={{ py: 2, px: 5 }} data-fade >
              Definitions
            </TypographyPopover>
            <TypographyPopover onClick={() => {
              navigate('/translations')
            }} sx={{ py: 2, px: 5 }} data-fade >
              Translations
            </TypographyPopover>
            <TypographyPopover onClick={() => {
              navigate('/audit')
            }} sx={{ py: 2, px: 5 }} data-fade >
              Audit
            </TypographyPopover>
            <TypographyPopover onClick={() => {
              navigate('/reports')
            }} sx={{ py: 2, px: 5 }} data-fade >
              Reports
            </TypographyPopover>
            <TypographyPopover onClick={() => {
              navigate('/prom')
            }} sx={{ py: 2, px: 5 }} data-fade >
              Prom questions
            </TypographyPopover>
            <TypographyPopover onClick={handleLogout} sx={{ py: 2, px: 5 }} data-fade >
              Log Out
            </TypographyPopover>
          </Popover>
        </UserContainer>
      )}
    </Main>
  )
}

export default HeaderRight
